import PersonaManager from "../../personas/PersonaManager"

type WazKBPersonasProps = {

}

export const WazKBPersonas = ({} : WazKBPersonasProps) => {

    return (
        <PersonaManager />
    )
}